import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FiPhone, FiMail } from 'react-icons/fi';
import '../styles/ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      const onlyNums = value.replace(/[^0-9]/g, '');
      if (onlyNums.length <= 10) {
        setFormData((prevData) => ({ ...prevData, [name]: onlyNums }));
      }
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone, message } = formData;

    if (!name || !email || !phone || !message) {
      toast.error('Please fill in all fields.');
      return;
    }

    if (!/^\d{10}$/.test(phone)) {
      toast.error('Phone number must be exactly 10 digits.');
      return;
    }

    try {
      await addDoc(collection(db, 'messages'), formData);
      toast.success('Message sent successfully!');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      toast.error('Failed to send message. Please try again.');
    }
  };

  return (
    <div className="contact-us">
      <ToastContainer />
      <h2>Get in touch with us</h2>

      <div className="contact-details">
        <div className="contact-info">
          <h3>Contact Us</h3>
          <p>
            12C Bharathi Nagar,<br />
            GN Mills, Thudiyalur Road,<br />
            Coimbatore, Tamil Nadu,<br />
            India - 641029
          </p>
          <br></br>
          <p>
            <FiPhone className="icon" />
            <a href="tel:+919629846693">+91 96298 46693</a>
          </p>
          <br></br>
          <p>
            <FiMail className="icon" />
            <a href="mailto:theshadeapp@gmail.com">theshadeapp@gmail.com</a>
          </p>
        </div>

        <div className="contact-form">
          <h3>Leave us a Message</h3>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="Enter your phone number"
                value={formData.phone}
                onChange={handleChange}
                pattern="\d{10}"
                title="Phone number must be exactly 10 digits"
                required
              />
            </div>

            <div className="input-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                placeholder="Write your message"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
